/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as ActionTypes from './actionTypes';

const initialState = {
  invNumCheckedResult: [],
  searchResult: [],
  invoiceNum: '',
  rebateProgram: '',
  rebateProgramList: [],
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  selectedRows: [],
  manufacturerList: [],
  reportQuarter: '',
  amountNdcDetails: [],
  ndcCodes: [],
  threshold: '',
  useBalanceThreshold: true,
  plan: '',
  errorMessages: [],
  dramsInvoice: '',
  earliestQtr: '',
  exportAllData: {},

  displayObj: {
    selectedPlanType: '',
    rebateProgram: '',
    selectedRows: [],
    reportQuarter: 'All',
    useBalanceThreshold: true,
    plan: '',
    isAll: false,
    invNumCheckedResult: [],
    searchResult: [],
    dramsInvoice: '',
    earliestQtr: '',
    rebateProgramList: [],
    rebateProgrameName: '',
    countValue: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_LIST:
    //   return { ...state, rebateProgramList: action.payload };

    case ActionTypes.SET_MANUFACTURERS_LIST:
      return { ...state, manufacturerList: action.payload };

    case ActionTypes.SET_SELECTED_INPUT:
      return { ...state, ...action.payload };
    case ActionTypes.SET_COMPUTED_FIELDS:
      return { ...state, computedFileds: action.payload };
    case ActionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE:
      return { ...state, dramsInvoice: action.payload };
    case ActionTypes.GET_EARLIEST_QTR_DRUG_VALUE:
      return { ...state, earliestQtr: action.payload };
    case ActionTypes.GET_QUARTERLY_PAYMENT_DATA:
      let displayObj = {
        ...state.displayObj,
        searchResult: action.payload,
      };
      return {
        ...state,
        searchResult: action.payload,
        displayObj,
      };
    case ActionTypes.GET_INVOICE_NUM_CHECKED_DATA:
      return { ...state, invNumCheckedResult: action.payload };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.SET_BALANCE_THREAD:
      return { ...state, threshold: action.payload };
    case ActionTypes.SET_AMOUNT_NDC_DETAILS:
      return { ...state, amountNdcDetails: action.payload };
    case ActionTypes.SET_NDC_CODES:
      return { ...state, ndcCodes: action.payload };
    case ActionTypes.SET_QUARTERLY_PAYMENT_REPORT_DATA_ALL:
      const exportAllData =
        action.key === 'noData'
          ? {}
          : { ...state.exportAllData, [action.key]: action.payload };
      return {
        ...state,
        exportAllData,
      };

    case ActionTypes.REFRESH_QUARTERLY_PAYMENT:
      return {
        ...state,
        rebateProgram: '',
        reportQuarter: 'All',
        useBalanceThreshold: true,
        isAll: false,
        plan: '',
      };
    case ActionTypes.REFRESH_QUARTERLY_PAYMENT_DISPLAY:
      return {
        ...state,
        rebateProgram: '',
        reportQuarter: 'All',
        useBalanceThreshold: true,
        isAll: false,
        plan: '',
      };
    case ActionTypes.SET_PAGINATION_INDEX_QUARTERLY:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };
    default:
      return state;
  }
};

export default reducer;
